module.exports = __webpack_public_path__ + "img/inquiry.26a736bd.svg";